import axios from 'axios'
import qs from 'qs'

export const Axios = axios.create({
    // baseURL: 'devCenter/v2',
    // baseURL: '/api'
    // baseURL: 'http://2413w46d92.zicp.vip/'
    baseURL: 'https://xialong.info/smartlock/'
});


//请求拦截器 => 加token、序列化data
Axios.interceptors.request.use(
    config => {
        let token = window.localStorage.getItem('token')
        if (token) {
            config.headers.token = token
        }

        //此处有一个巨坑，Content-Type为multipart/form-data时，不要再处理config中的data，否则提交会失败
        //参考链接： https://blog.csdn.net/qq_41688165/article/details/80834842
        if (config.headers['Content-Type'] != 'multipart/form-data;') {
            if (typeof(config.data) == 'object') {
                config.data = qs.stringify(config.data)
            }
        }
        return config
    },
    error => {
        console.error(error)
        return Promise.reject(error)
    }
)


export const submitFormData = async(params, url) => {
    let formData = new FormData();
    for (let key in params) {
        let value = params[key]
        formData.append(key, value)
    }
    return await Axios({
        method: "POST",
        url,
        url,
        data: formData,
        headers: {
            'Content-Type': `multipart/form-data;`
        }
    })
};

export const submitApplicationJson = async(url, params) => {
    return await Axios({
        method: "POST",
        url,
        url,
        data: JSON.stringify(params),
        headers: {
            'Content-Type': `Application/json;`
        }
    })
};


// WEBPACK FOOTER //
// ./src/fetch/index.js